module.exports = __webpack_public_path__ + "images/avatars/male/3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/3.svg
// module id = anIN
// module chunks = 153